import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { BookStack } from './BookStack';
import { heroChips } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-69" data-mp="9ka71249uyyi">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" style={{
      paddingTop: "0px"
    }} data-id="element-70" data-mp="9igwhbqjful8">
        <h1 className="mx-auto mt-2 max-w-2xl font-display text-[23px] font-black uppercase leading-tight text-plum sm:text-[34px]" style={{
        paddingTop: "8px",
        marginTop: "-10px",
        marginBottom: "-10px"
      }} data-id="element-71" data-mp="129h6c3bjvskt">
          Finish your <span className="text-grape" data-id="element-72" data-mp="sa027qby5mqy">progress notes</span> before you <span className="text-blush" data-id="element-73" data-mp="ncq13df73mna">leave the office</span>
        </h1>

        <p className="pb-5 pt-3 font-display text-[11px] font-bold uppercase tracking-[0.2em] text-plum/60 sm:text-sm" style={{
        paddingTop: "17px",
        paddingBottom: "10px"
      }} data-id="element-74" data-mp="nekl8pin7aqb">
          120 ready-to-use AI prompts for progress notes, treatment plans, session prep, client handouts and practice admin
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-2xl" data-id="element-75" data-mp="3o7vk1k75dnxa">
          <BookStack data-id="element-76" data-mp="30iaxysfp6ajs" />
        </motion.div>

        <p className="mt-4 text-[10px] font-semibold uppercase tracking-[0.18em] text-plum/50" data-id="element-77" data-mp="30ggdff8c8kg8">
          100+ AI PROMPTS FOR THERAPISTS & COUNSELORS™ — 6 Volumes + 4 Bonuses · The SIGMA SMART™ Method · ⚡ Instant Access
        </p>

        <div className="mt-8 flex flex-col items-center" data-id="element-78" data-mp="2qi0mpdd83d79">
          <CTAButton href="#pricing" data-id="element-79" data-mp="2vjq02znx42yi">See the 100+ AI Prompts for Therapists</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-80" data-mp="2hk84a0c7fpfn">
            <span className="font-bold text-plum" data-id="element-81" data-mp="2ll0eowwtc0di">BUILT FOR CLINICIANS, NOT FOR TECH PEOPLE.</span> Designed for therapists,
            counselors, clinical social workers, MFTs and psychologists who want clear, professional documentation
            without spending their evenings on paperwork.
          </p>

          <h2 className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-grape-deep sm:text-xl" data-id="element-82" data-mp="id9vei3jojvx">
            Progress Notes · Treatment Plans · Sessions · Handouts · Practice Admin · Self-Care
          </h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-83" data-mp="1azkv7qjbugro">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-grape/20 bg-white/80 px-3.5 py-1.5 text-xs font-semibold text-plum/80" data-id="element-84" data-mp="112pwp7n20gde">
                <Icon className="h-3.5 w-3.5 text-grape" data-id="element-85" data-mp="x37bsbv8g5ak" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-plum/50" data-id="element-86" data-mp="3hrd8esqpz5yu">
            - Everything you need in one single toolkit -
          </p>
        </div>
      </div>
    </header>;
}